module.exports = __webpack_public_path__ + "static/media/needle_lightmode.f32d4063.png";